import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';
// @ts-ignore
import {ReactComponent as arrow_top_middle} from '../../../assets/arrows/edit/arrow_top_middle.svg';

const ArrowTopMiddle: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} component={arrow_top_middle} viewBox='0 0 167 168' />
  );
};

export default ArrowTopMiddle;
